import React, { useState } from 'react'
import './InputField.css'
import { TextField, InputAdornment, IconButton,  } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function InputField( { id, placeholder, type, onChange, value, required = true, isValid = true }) {

    const [showPassword, setShowPassword] = useState(false)

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    switch(type) {
        case 'password':
            return (<TextField
              fullWidth
              id={id}
              label={placeholder}
              value={value ? value : ''}
              onChange={onChange}
              name={id}
              required={required}
              error={!isValid}
              helperText={!isValid ? 'Please enter a valid value' : ''}
              sx={{ marginBottom: 2}}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: 
                    (<InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>)
                  
              }}
              
            />)

        case 'date':
            return (<DatePicker 
                onChange={onChange}
                inputFormat={"MM/DD/YYYY"}
                mask={"__/__/____"}
                value={value}
                label={placeholder}
                id={id}
                name={id}
                renderInput={(params) => <TextField 
                    fullWidth 
                    required={required}
                    error={!isValid}
                    helperText={!isValid ? 'Please enter a valid date' : ''}
                    sx={{ marginBottom: 2}}
                    {...params} />}
            />)

        case 'time':
            return (<TextField 
                id={id}
                name={id}
                value={value}
                onChange={onChange}
                fullWidth
                required={required}
                error={!isValid}
                label={placeholder}
                type="time"
                InputLabelProps={{ shrink: true }}
                helperText={!isValid ? 'Please enter a valid time' : ''}
            />)

        case 'textarea':
            return (<TextField 
                fullWidth
                multiline
                rows={4}
                id={id}
                label={placeholder}
                value={value ? value : ''}
                onChange={onChange}
                name={id}
                required={required}
                error={!isValid}
                helperText={!isValid ? 'Please enter a valid value' : ''}
                sx={{ marginBottom: 2}}
            />)

        default:
            return (
                <TextField 
                    fullWidth
                    id={id}
                    label={placeholder}
                    value={value ? value : ''}
                    onChange={onChange}
                    name={id}
                    required={required}
                    error={!isValid}
                    helperText={!isValid ? 'Please enter a valid value' : ''}
                    sx={{ marginBottom: 2}}
                />)
    }
}